module.exports = __webpack_public_path__ + "static/media/agregar-estudio.4b43b59a.png";